import type { Ref } from 'react';
import { Button } from '../../ui/kit/components/primitives';

interface Props {
  name: string;
  startOpen: boolean;
  startRef: Ref<HTMLButtonElement>;
  onStart: () => void;
}

function greeting(hour: number) {
  if (hour < 5) return 'Working late';
  if (hour < 12) return 'Good morning';
  if (hour < 18) return 'Good afternoon';
  return 'Good evening';
}

export default function ProductionHero({ name, startOpen, startRef, onStart }: Props) {
  const now = new Date();
  const today = now.toLocaleDateString(undefined, { weekday: 'short', day: 'numeric', month: 'short' });
  return <header className="studio-home-hero studio-home-reveal" aria-label="Studio floor">
    <div className="studio-home-hero-copy">
      <p className="bs-eyebrow">Studio floor · {today}</p>
      <h1>{greeting(now.getHours())}, {name}</h1>
      <p className="bs-muted">Pick up a production where you left it, or bring the next brief.</p>
    </div>
    <Button ref={startRef} variant="primary" size="lg" icon="plus" aria-haspopup="dialog" aria-expanded={startOpen} onClick={onStart}>New production</Button>
  </header>;
}
